<template>
  <v-dialog v-model="dialog" persistent max-width="700">
    <v-card>
      <v-card-title class="headline">
        Start analysis process for {{ numberOfRows }} row(s)?
      </v-card-title>
      <v-card-text>
        <v-stepper v-model="stepper" class="elevation-0" vertical>
          <v-stepper-step editable :complete="stepper > 1" step="1">
            Select an import Session
            <small>Select a correct import session or create the new one</small>
          </v-stepper-step>

          <v-stepper-items>
            <v-stepper-content step="1">
              <SessionsPicker
                v-if="task_id"
                ref="sessionPicker"
                :task_id="task_id"
                @onEnvChanged="onEnvChanged"
              ></SessionsPicker>
            </v-stepper-content>
            <v-stepper-step :complete="stepper > 2" step="2">
              Agreement
            </v-stepper-step>
            <v-stepper-content step="2">
              <span class="error--text text-h6">
                By this action you start analysis process for all rows with
                selected filters. (statuses/filters/tabs). Do you really want to
                make this changes?
              </span>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="close">Disagree</v-btn>
        <v-btn
          color="primary"
          text
          @click="agree"
          :loading="loading"
          :disabled="numberOfRows === 0 && isSessionCorrect"
        >
          <span v-if="isSessionCorrect">Agree</span>
          <span v-else>Create Session</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import SessionsPicker from './SessionsPicker';
export default {
  props: {
    numberOfRows: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      dialog: false,
      valid: true,
      stepper: 1,
      task_id: undefined,
      loading: false,
      isSessionCorrect: true
    };
  },
  components: {
    SessionsPicker
  },
  methods: {
    open(task_id) {
      this.task_id = task_id;
      this.stepper = 1;
      this.valid = true;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.task_id = undefined;
    },
    agree() {
      if (this.stepper == 1) {
        if (!this.isSessionCorrect) {
          this.loading = true;
          return this.$refs.sessionPicker
            .createImportSession()
            .then(() => {
              this.isSessionCorrect = this.$refs.sessionPicker.isSessionExists(
                this.$refs.sessionPicker.selectedEnv
              );
              this.stepper++;
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        } else this.stepper++;
      } else {
        this.$emit('onAgree');
        this.close();
      }
    },
    onEnvChanged(env) {
      this.isSessionCorrect = this.$refs.sessionPicker.isSessionExists(env);
      this.$emit('onEnvChanged', this.$refs.sessionPicker.selectedEnv);
    }
  }
};
</script>
